import { render, staticRenderFns } from "./sectionDataPreview.vue?vue&type=template&id=23e7b8a8"
import script from "./sectionDataPreview.vue?vue&type=script&lang=js"
export * from "./sectionDataPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports